import { defineComponent as a, computed as i, openBlock as s, createBlock as l, unref as o, withCtx as n, createElementVNode as p, normalizeClass as c, createVNode as f, mergeProps as m, renderSlot as u } from "vue";
import { RevLink as d } from "@ds/components/Link";
import { RevPortal as h } from "@ds/components/Portal";
import { tw as y } from "../../utils/tailwind.js";
const _ = /* @__PURE__ */ a({
  name: "RevSkipToContent",
  inheritAttrs: !1,
  __name: "SkipToContent",
  props: {
    toAnchorId: { default: "#main-content" },
    to: { default: "body" }
  },
  setup(t) {
    const r = i(() => y`bg-static-info-max
  fixed inset-x-0 top-0 w-full -translate-y-full px-16
  py-12 opacity-5 transition
  focus-within:translate-y-0 focus-within:opacity-100
  `);
    return (e, w) => (s(), l(o(h), { to: t.to }, {
      default: n(() => [
        p("div", {
          class: c(r.value)
        }, [
          f(o(d), m({
            class: "px-4 py-2",
            to: t.toAnchorId
          }, e.$attrs), {
            default: n(() => [
              u(e.$slots, "default")
            ]),
            _: 3
          }, 16, ["to"])
        ], 2)
      ]),
      _: 3
    }, 8, ["to"]));
  }
});
export {
  _ as default
};
